import React from "react";

const EarlyOptions = ({ options }) => (
  <div className="payment-plan-card__early">
    <div className="payment-plan-card__early-title">EARLY OWNERSHIP OPTIONS</div>
    {options.map((opt) => (
      <div key={opt.label} className="payment-plan-card__early-row">
        <div className="payment-plan-card__early-label">{opt.label}</div>
        <div className="payment-plan-card__early-text">{opt.text}</div>
      </div>
    ))}
  </div>
);

export default EarlyOptions;
